// extracted by mini-css-extract-plugin
export default {"header":"HeaderBig_header__yeSqe","menuContainer":"HeaderBig_menuContainer__ZRzg8","title":"HeaderBig_title__CdMwV","textContainer":"HeaderBig_textContainer__QQXuX"};